import { Menu } from 'antd';
import { selectedMenuKeysSelector } from 'features/appUI/selectors';
import { setSelectedMenuKeys } from 'features/appUI/slice';
import {
  amusementTicketMenuItems,
  hotelMenuItems,
  tourMenuItems,
} from 'layouts/MainLayout/constants';
import { useAppDispatch, useAppSelector } from 'lib/stores/hook';
import type { MenuInfo } from 'rc-menu/es/interface';
import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAppModules } from 'routes/helpers';
import { MODULE_TYPE } from 'utils/constants';

const AppMainSidebar = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const selectedMenuKeys = useAppSelector(selectedMenuKeysSelector);

  const handleClickMenuItem = useCallback(
    (info: MenuInfo) => {
      const { key: navigationPath } = info;
      dispatch(setSelectedMenuKeys([navigationPath]));
      navigate(navigationPath);
    },
    [dispatch, navigate]
  );

  const { type: moduleType } = getAppModules();

  const menuItems = useMemo(
    () => [
      ...(moduleType === MODULE_TYPE.HOTEL ? hotelMenuItems : []),
      ...(moduleType === MODULE_TYPE.TOUR ? tourMenuItems : []),
      ...(moduleType === MODULE_TYPE.AMUSEMENT_TICKETS
        ? amusementTicketMenuItems
        : []),
    ],
    [moduleType]
  );

  useEffect(() => {
    dispatch(setSelectedMenuKeys([location.pathname]));
  }, [dispatch, location.pathname]);

  return (
    <Menu
      mode="inline"
      items={menuItems}
      theme="dark"
      onClick={handleClickMenuItem}
      selectedKeys={selectedMenuKeys}
    />
  );
};

export default memo(AppMainSidebar);
